if (!customElements.get("product-recommendations")) {
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      this.fetchRecommendations();

      this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
        this.fetchRecommendations();
      });

      this.cartAddUnsubscriber = subscribe(PUB_SUB_EVENTS.cartAdd, () => {
        this.fetchRecommendations();
      });
    }

    disconnectedCallback() {
      if (this.cartUpdateUnsubscriber) this.cartUpdateUnsubscriber();
      if (this.cartAddUnsubscriber) this.cartAddUnsubscriber();
    }

    async fetchRecommendations() {
      const productIds = this.productIds;
      if (!productIds.length) {
        this.parentWrapper.style.display = "none";
        return;
      }

      const sectionId = "product-recommendations";
      const rootUrl = window.routes.root_url;
      const allRecommendedHtml = [];
      const seenProductIds = new Set(productIds);

      for (const productId of productIds) {
        try {
          const url = `${rootUrl}recommendations/products?product_id=${productId}&limit=${this.productLimit}&section_id=${sectionId}`;
          const response = await fetch(url);
          if (!response.ok) continue;

          const text = await response.text();
          const html = new DOMParser().parseFromString(text, "text/html");
          const cards = html.querySelectorAll(`[data-type="${this.type}"]`);

          cards.forEach((card) => {
            const id = card.querySelector("[data-product-id]").getAttribute("data-product-id");
            if (!seenProductIds.has(Number(id))) {
              seenProductIds.add(Number(id));
              allRecommendedHtml.push(card.outerHTML);
            }
          });
        } catch (error) {
          console.error("Error fetching recommendations:", error);
        }

        if (allRecommendedHtml.length >= this.productLimit) break;
      }

      if (allRecommendedHtml.length) {
        this.innerHTML = allRecommendedHtml
          .slice(0, this.productLimit)
          .join("");
        this.parentWrapper.style.display = "";

        window.swymCollectionsLoaded?.();
      } else {
        console.info("No recommendations found");
        this.parentWrapper.style.display = "none";
      }
    }

    get productIds() {
      try {
        const attr = this.getAttribute("data-items") || "[]";
        const items = attr.startsWith("[") ? JSON.parse(attr) : [{ product_id: attr }];
        return items.map((item) => item.product_id);
      } catch {
        return [];
      }
    }

    get productLimit() {
      return this.getAttribute("data-limit") || 4;
    }

    get type() {
      return this.getAttribute("data-type") || "normal";
    }

    get parentWrapper() {
      return this.closest(".section-wrapper") || this.parentElement;
    }
  }

  customElements.define("product-recommendations", ProductRecommendations);
}